/** Те же шкалы, что у матрицы категорий: чем выше доля тональности, тем насыщеннее оттенок. */
export const RED_PALETTE = [
  '#fee2e2',
  '#fecaca',
  '#fca5a5',
  '#f87171',
  '#ef4444',
  '#dc2626',
  '#b91c1c',
  '#991b1b',
] as const;

export const YELLOW_PALETTE = [
  '#fef9c3',
  '#fef08a',
  '#fde047',
  '#facc15',
  '#eab308',
  '#ca8a04',
  '#a16207',
  '#854d0e',
] as const;

export const GREEN_PALETTE = [
  '#dcfce7',
  '#bbf7d0',
  '#86efac',
  '#4ade80',
  '#22c55e',
  '#16a34a',
  '#15803d',
  '#166534',
] as const;

/** Соответствует шагам colorScale матрицы: percent 0–100 → индекс в палитре. */
export function paletteColorForSentimentPercent(
  palette: readonly string[],
  percent: number,
): string {
  const n = palette.length;
  const p = Math.max(0, Math.min(100, percent));
  const idx = Math.min(n - 1, Math.floor((p / 100) * n));
  return palette[idx] ?? palette[0];
}

/** Цвет плитки по долям позитива/негатива, как насыщенность ячеек матрицы по столбцу. */
export function fillColorFromPositiveNegative(positive: number, negative: number): string {
  const total = positive + negative;
  if (total <= 0) return '#e5e7eb';
  const posPct = (positive / total) * 100;
  const negPct = (negative / total) * 100;
  if (negative > positive) {
    return paletteColorForSentimentPercent(RED_PALETTE, negPct);
  }
  if (positive > negative) {
    return paletteColorForSentimentPercent(GREEN_PALETTE, posPct);
  }
  const mid = Math.floor(YELLOW_PALETTE.length / 2);
  return YELLOW_PALETTE[mid] ?? '#fde047';
}
